import React, {
  Component,
  Fragment,
  useEffect,
  useMemo,
  useState,
} from "react";

import users from "../../assets/images/icon_home/user.svg";
import * as API from "../../core/service/api.js";
import {} from "../../core/feature/store";
import * as api_card from "../../core/service/api_card";
import { useAppSelector, useAppDispatch } from "../../core/feature/hooks";
import {
  Link,
  Navigate,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import "react-lazy-load-image-component/src/effects/blur.css";
import { formatCurrency } from "../../config/global";
import User from "../../core/models/user";
import Config from "../../config/Config";
import { useDispatch } from "react-redux";
import TabsMobile from "../__template/TabsMobileComponent";
import { useTranslation } from "react-i18next";
import emptyIcon from "../../assets/images/empty-data.svg";

const SyncHistoryMobile = () => {
  const user: User = useAppSelector((state) => state.user.user);
  const [history, setHistory] = useState([]);
  const cardData = JSON.parse(String(localStorage.getItem("card")));
  const navigate = useNavigate();
  const { t } = useTranslation();
  const location = useLocation();
  const { id } = useParams();
  const [syncDate, setSyncDate] = useState(location?.state?.syncDate);

  const env = Config.BaseUrlDev;

  useEffect(() => {
    if (user == undefined) {
      navigate("/login", { replace: true });
    }
    console.log(cardData);

    cardData.map((data: any) => {
      if (data.id == id && syncDate) {
        console.log("ketemu");
        setHistory(cardData);
      }
    });
  }, []);

  function getImgContent(url: string) {
    return env + "main_a/image/get/" + url + "/pas";
  }

  function getCurrency(str: any) {
    return formatCurrency(str).replace(",00", "");
  }

  return (
    <>
      <div className="relative min-h-screen h-full  bg-psp-primary pb-10">
        <div className="bg-white px-8 pt-8 pb-3  sticky top-0">
          <TabsMobile
            name={`${t("DIGITALCARD.syncHistory")}`}
            backUrl={"digital-card"}
          ></TabsMobile>
        </div>
        <div className="min-h-screen h-full mb-6 px-4 py-2 bg-psp-primary">
          <section className="mt-1">
            {history?.map((data: any) => {
              return (
                <div
                  key={data.id}
                  className="bg-white rounded-xl shadow-md font-montserrat mb-2"
                >
                  <div className="px-3 pt-3">
                    <div className="font-light text-xs">
                      NFC ID: {data.nfcId}
                    </div>
                  </div>
                  <div className="flex flex-row px-3 py-3 gap-2 items-center">
                    <div className="w-full flex justify-between">
                      <div className="font-bold text-xs">{data.callerName}</div>
                      <div className="font-bold text-blue-700 text-xs">
                        {syncDate}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
            {!history.length && (
              <div className="flex flex-col items-center mt-4">
                <div>
                  <img src={emptyIcon} alt="" />
                </div>
                <div>{t("DIGITALCARD.emptyHistory")}</div>
              </div>
            )}
          </section>
        </div>
      </div>
    </>
  );
};

export default SyncHistoryMobile;
